<template>
  <div @click="activity">
    <confirm ref="confirm"></confirm>
    <v-overlay :value="!$loader.loaded" z-index="250">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-app v-if="!isFullScreen">
      <drawer-dialog-root />
      <core-main-menu
        v-if="$loader.first_loaded == true && $store.state.auth.auth"
        :n-unread-notifications="nUnreadNotifications"
        @open-notifications="setIsNotificationListOpen(true)"
      />
      <core-view />
      <v-speed-dial
        v-model="fab"
        direction="top"
        fixed
        bottom
        right
        fab
        transition="slide-y-reverse-transition"
        v-if="$store.state.auth.checkAccess({key: 'kiosk.access', value: true}) || $store.state.auth.checkAccess({key: 'cms', value: true})"
      >
        <template v-slot:activator>
          <v-btn
            v-model="fab"
            color="green darken-2"
            dark
            small
            fab
          >
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-book-multiple</v-icon>
          </v-btn>
        </template>
        <v-btn
          fab
          dark
          small
          color="teal"
          title="Kiosk"
          v-if="$store.state.auth.checkAccess({key: 'kiosk.access', value: true})"
          @click="$store.commit('app/setPanel', 'kiosk')"
        >
          <v-icon>mdi-store-outline</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="indigo"
          title="CMS"
          v-if="$store.state.auth.checkAccess({key: 'cms', value: true})"
          @click="$store.commit('app/setPanel', 'cms')"
        >
          <v-icon>mdi-file-document-edit-outline</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="green"
          title="CRM"
          @click="$store.commit('app/setPanel', 'default')"
        >
          <v-icon>mdi-monitor-dashboard</v-icon>
        </v-btn>
      </v-speed-dial>
      <v-snackbar
        v-model="$notification.show"
        :color="$notification.type"
        :timeout="3000"
        :top="$notification.position?.top || true"
        :right="$notification.position?.right"
        dark
      >
        <div class="d-flex justify-space-between">
          <div class="d-flex flex-column justify-center">
              <span v-html="$sanitize($notification.message)"></span>
          </div>
          <v-btn
            icon
            @click="$notification.show = false"
          >
            <v-icon>
              mdi-close-circle
            </v-icon>
          </v-btn>
        </div>
      </v-snackbar>
      <!--    <core-footer/>-->
      <notification-container
        v-if="isListOpen"
      />
    </v-app>

    <v-app v-else>
      <core-view />


      <v-snackbar
        v-model="$notification.show"
        :color="$notification.type"
        :timeout="3000"
        :top="$notification.position?.top || true"
        :right="$notification.position?.right"
        dark
      >
        <div class="d-flex justify-space-between">
          <div class="d-flex flex-column justify-center">
              <span v-html="$sanitize($notification.message)"></span>
          </div>
          <v-btn
            icon
            @click="$notification.show = false"
          >
            <v-icon>
              mdi-close-circle
            </v-icon>
          </v-btn>
        </div>
      </v-snackbar>
    </v-app>
  </div>
</template>

<style>
  tr.dirty * {
    font-weight: bolder;
    color: #777;
  }

  .v-data-table__progress th {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .dt-table.footer-padding .v-data-footer {
    padding-right: 45px;
  }
</style>

<script>

  import moment from 'moment'
  import Confirm from '@/components/core/Confirm'
  import CoreView from '@/components/core/View'
  import CoreMainMenu from '@/components/core/MainMenu'
  import CoreFooter from '@/components/core/Footer'

  import '@/assets/css/base.css'
  import { DrawerDialogRoot } from './components/core/DrawerDialog'
  import SocketMixin from '@/components/core/SocketMixin.js'
  import { mapActions, mapGetters } from 'vuex'
  import NotificationContainer from './modules/notifications/containers/NotificationContainer.vue'
  // import Notification from '@/components/core/Notification.vue'

  window.dateRangeList = [
    {
      text: 'Today',
      value: {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      },
    },
    {
      text: 'Yesterday',
      value: {
        from: moment().subtract(1, 'day').format('YYYY-MM-DD'),
        to: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      },
    },
    {
      text: 'This Week',
      value: {
        from: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        to: moment().endOf('isoWeek').format('YYYY-MM-DD'),
      },
    },
    {
      text: 'This Month',
      value: {
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().endOf('month').format('YYYY-MM-DD'),
      },
    },
    {
      text: 'This Year',
      value: {
        from: moment().startOf('year').format('YYYY-MM-DD'),
        to: moment().endOf('year').format('YYYY-MM-DD'),
      },
    },
    {
      text: 'Last 14 days',
      value: {
        from: moment().subtract(14, 'day').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      },
    },
    {
      text: 'Last 30 days',
      value: {
        from: moment().subtract(30, 'day').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      },
    },
    {
      text: 'Last Month',
      value: {
        from: moment().startOf('month').subtract(1, 'day').startOf('month').format('YYYY-MM-DD'),
        to: moment().startOf('month').subtract(1, 'day').format('YYYY-MM-DD'),
      },
    },
    {
      text: 'Last Year',
      value: {
        from: moment().startOf('year').subtract(1, 'day').startOf('year').format('YYYY-MM-DD'),
        to: moment().startOf('year').subtract(1, 'day').format('YYYY-MM-DD'),
      },
    },
    {
      text: 'All',
      value: {
        from: '2000-01-01',
        to: moment().format('YYYY-MM-DD'),
      },
    },
  ]

  export default {
    components: {
      // Notification,
      DrawerDialogRoot,
      NotificationContainer,
      CoreMainMenu,
      CoreFooter,
      CoreView,
      Confirm
    },
    mixins: [ SocketMixin ],
    data: () => ({
      fab: false,
    }),
    computed: {
      isFullScreen () {
        return this.$route.meta.isFullScreen
      },
      ...mapGetters('notification', {
        nUnreadNotifications: 'nUnread',
        isListOpen: 'isListOpen',
      })
    },

    created () {
      this.$nextTick(() => {
        this.$root.$confirm = this.$refs.confirm.open
      })
    },

    methods: {
      ...mapActions('notification', {
        initializeNotificationStorage: 'load',
        setIsNotificationListOpen: 'setIsListOpen',
      }),
      activity () {
        return this.$store.dispatch('auth/setAction', { type: 'click' }).catch(err => {
        })
      }
    },

    watch: {
      '$store.state.auth.auth': {
        handler(yes) {
          if (yes) {
            this.initializeNotificationStorage(true)
          }
        },
        immediate: true,
      }
    }

  }
</script>
<style lang="scss" scoped>
  .notificationContainer {
    position: fixed;
    top: 10px;
    right: 10px;
    display: grid;
    grid-gap: 0.5em;
    z-index: 99;
  }
</style>
